import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-guest-entry-component',
  templateUrl: './guest-entry-component.component.html',
  styleUrls: ['./guest-entry-component.component.scss']
})
export class GuestEntryComponentComponent {
  baseUrl: string;
  cmpyId: string;
  constructor(@Inject(DOCUMENT) private readonly document: Document) { }

  gotoButton() {
    this.baseUrl = this.document.baseURI;
    this.setCmpyId();
    const relativePath = `guest/booking/${this.cmpyId}`;
    const fullUrl = new URL(relativePath, this.baseUrl).href;
    window.location.href = fullUrl;
  }
  
  setCmpyId() {
    const envMapping = {
      "//trucklots.com/": "2F73880A-8005-40E9-7B44-08DC9F1507FB",
      "demo": "3f9fdc75-7818-414d-8d04-08dcc2723213",
      "qa": "6B9F097C-BA6F-4CAF-66FE-08DC309C6858",
      "dev": "BE521A91-B5F7-4585-C115-08DBD0AC75E5",
      "localhost": "6B9F097C-BA6F-4CAF-66FE-08DC309C6858",
    };
    const envKey = Object.keys(envMapping).find(env => this.baseUrl.includes(env));
    this.cmpyId = envMapping[envKey];
  }
  
}
